
export function setUpNextSectionLinks() {
    document.querySelectorAll( '[href="#next-section"]' ).forEach( nextLink => {
        nextLink.addEventListener( 'click', event => {
            event.preventDefault();
            const parent = event.currentTarget.closest( 'section' );
            const nextElement = parent.nextElementSibling;
            nextElement.scrollIntoView();
        })
    } );
}


export function fadeLoadLazyImages() {
    document.querySelectorAll( 'img[loading="lazy"]' ).forEach( image => {
        const handler = e => {
            e.currentTarget.classList.remove( 'loading' );
            e.currentTarget.animate( {
                opacity: [0, 1]
            }, 600 );
        };
        image.addEventListener( 'load', handler, {
            once: true
        } );
        if ( !image.complete ) image.classList.add( 'loading' );
        else image.removeEventListener( 'load', handler );
    } );
}
